export const LOADING = 'LOADING'
export const GET_ALL_MERCHANTS = 'GET_ALL_MERCHANTS'
export const GET_SINGLE_MERCHANT = 'GET_SINGLE_MERCHANT'
export const UPDATE_MERCHANT = 'UPDATE_MERCHANT'
